import { Injectable } from '@angular/core'
import { CollectionRepository, FirestoreQueryBuilder } from '@engineering11/web-api-firebase'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { COLLECTIONS } from 'shared-lib'
import { IJobPost, JobPostStatus } from '../models/job-post.model'

@Injectable({ providedIn: 'root' })
export class JobPostRepository extends CollectionRepository<IJobPost> {
  protected COLLECTION = COLLECTIONS.JOB_POST

  getActiveJobPostsByCustomer(customerKey: string): Observable<IJobPost[]> {
    const query = new FirestoreQueryBuilder<IJobPost>()
      .where('customerKey', '==', customerKey)
      .where('status', '==', JobPostStatus.Published)
      .orderBy('jobTitle')
      .build()
    return this.queryValueChanges(query)
  }

  /**
   * One published post, live — as a QUERY, not a document listen. Before a first publish lands the
   * document does not exist, and the read rule (`existingData().customerKey`) denies listening to a missing
   * document; a query constrained on the caller's own customerKey is allowed and simply returns nothing
   * until the document is created, then delivers it.
   */
  getPublishedValueChanges(id: string | undefined, customerKey: string | undefined): Observable<IJobPost | undefined> {
    // Never build a query with an undefined value: Firestore fails an internal assertion and takes the whole
    // client down with it (every listener on the page stops). A brand-new draft has no id yet.
    if (!id || !customerKey) return of(undefined)
    const query = new FirestoreQueryBuilder<IJobPost>().where('customerKey', '==', customerKey).where('id', '==', id).build()
    return this.queryValueChanges(query).pipe(map(posts => posts[0]))
  }
}
